import { render } from "./InheritModal.vue?vue&type=template&id=1904cfa6"
import script from "./InheritModal.vue?vue&type=script&lang=js"
export * from "./InheritModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__